/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersexportcsv2Inputs */

const en_partnersexportcsv2 = /** @type {(inputs: Partnersexportcsv2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export as CSV`)
};

const de_partnersexportcsv2 = /** @type {(inputs: Partnersexportcsv2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als CSV exportieren`)
};

/**
* | output |
* | --- |
* | "Export as CSV" |
*
* @param {Partnersexportcsv2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersexportcsv2 = /** @type {((inputs?: Partnersexportcsv2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersexportcsv2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersexportcsv2(inputs)
	return de_partnersexportcsv2(inputs)
});
export { partnersexportcsv2 as "partnersExportCsv" }